import React from "react";
import { motion } from "motion/react";
import { fadeInUp } from "./AnimationVariants";
import { HeroStats } from "./HeroStats";
import { PrimaryActions } from "./PrimaryActions";
import LemonadeTrainingLogo from "../../assets/LOGO_trademark.PNG";

export function HeroContent() {
  return (
    <div className="flex flex-col items-center lg:items-start text-center lg:text-left z-10 max-w-md lg:max-w-xl">
      {/* Logo - left aligned */}
      <motion.div variants={fadeInUp}>
        <img
          src={LemonadeTrainingLogo}
          alt="Lemonade Training"
          className="w-[270px] sm:w-[440px] lg:w-[480px] h-auto mb-8 lg:mb-10 drop-shadow-2xl"
          style={{ filter: "drop-shadow(0 8px 16px rgba(0, 0, 0, 0.3))" }}
        />
      </motion.div>

      {/* One fixed column width shared by the paragraph, buttons and divider */}
      <div className="w-full sm:w-[440px] lg:w-[480px]">
        <motion.h1
          variants={fadeInUp}
          className="text-base lg:text-lg font-normal text-white leading-relaxed tracking-normal mb-8 lg:mb-10 text-pretty"
        >
          Where your gym trains together.{" "}
          <span className="text-white/60">
            Classes, programming and payments in one app your members actually open.
          </span>
        </motion.h1>

        <PrimaryActions className="w-full" />

        <HeroStats />
      </div>
    </div>
  );
}
